function loadFonts() {
  Array.prototype.forEach.call(document.querySelectorAll('link.fontstylesheet'), function (link) {
    link.rel = 'stylesheet';
  });
}

module.exports = {
  loadFonts: loadFonts
};



//////////////////
// WEBPACK FOOTER
// ./src/js/helpers/fontStylesheet.js
// module id = 45
// module chunks = 0